export const initialViewport = {
    latitude: 46.154,
    longitude: 14.8721,
    zoom: 7.5,
    width: '100%',
    height: '100%'
};

export const poiZoomValue = 16.5;

export const mapStyles = [
    {
        default: true,
        slug: 'outdoor',
        name: 'Teren',
        url: 'mapbox://styles/leonskrilec/ckiof4bwt4pve17p3bf3el3bt'
    },
    {
        slug: 'satellite',
        name: 'Satelit',
        url: 'mapbox://styles/leonskrilec/ckhutz9hg00tg19tem0vulw4q'
    }
];
